export const ERROR_STATES = [
  'Обработка не начата',
  'Нет ответа',
  'Номер занят',
  'Номер запрещен',
  'Прочие ошибки',
  'Потеря пакетов данных',
  'Ошибка синхронизации между каналом и сокетом',
  'Произведено подключение',
];
